import { useSearchParams } from "react-router-dom";
import OsttraBg from "../../images/osttra-bg.png";
import ErrorDetails from "../../types/ErrorDetails";
import { getErrorDetails } from "../../utils/ErrorCodesUtil";
import { getCurrentYear } from "../../utils/Utils";
import "./ErrorPage.css";

const ErrorPage = ({
  errorMessage = "The error is probably temporary, so please wait for a few seconds and then refresh the page. If the issue persists after several minutes, please contact OSTTRA Support team",
  errorCode,
}: {
  errorMessage?: string;
  errorCode?: number;
}) => {
  let locationURL: string =
    window.location.host === "localhost:3001" ? `http://${window.location.host}` : `https://${window.location.host}`;
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  const errorDetails: ErrorDetails = getErrorDetails(error);

  return (
    <div className="t-error-page">
      <img src={OsttraBg} alt="osttra-background" className="osttra-background" />
      <div className="t-error-container">
        {errorCode === 404 ? <h1>Page Not Found</h1> : <h1>Something went wrong</h1>}
        <p>{errorDetails.errorMessage || errorMessage}</p>

        <h2 className="error-txt">
          If you think you should be able to access this page, contact OSTTRA Support with error details like below:
        </h2>
        <p className="error-support-text">
          Find OSTTRA Support contacts here - <a href="https://osttra.com/support/">https://osttra.com/support/</a>
        </p>
        <></>
        <h2>Status:</h2>
        <dl className="t-error-container__meta-data" aria-label="meta-data">
          <dt>Response code</dt>
          <dd>{errorDetails.errorCode || errorMessage}</dd>
          <dt>Time</dt>
          <dd>{new Date().toUTCString()}</dd>
          <dt>URL</dt>
          <dd>{locationURL}</dd>
        </dl>

        <footer className="footer">
          © {getCurrentYear} OSTTRA Group. Proprietary and Confidential.{" "}
          <a href="https://osttra.com/disclaimer/" target="_blank" rel="noopener noreferrer">
            Disclaimer
          </a>
        </footer>
      </div>
    </div>
  );
};

export default ErrorPage;
